// extracted by mini-css-extract-plugin
module.exports = {"container":"SubSection_container__RrOim","actions":"SubSection_actions__7R7Nm","count":"SubSection_count__3clkx","name":"SubSection_name__Ojc0U"};